export default {
  label: "Configurador",
};
